export type EditTopMakesApiResponse = unknown;
export type EditTopMakesApiArg = {
  editTopMakesRequestBody: EditTopMakesRequestBody;
};
export type GetTopMakesApiResponse = /** status 200  */ TopMakeResponseBody[];
export type EditTopMakesRequestBody = {
  makes: string[];
};
export type TopMakeResponseBody = {
  code: string;
};
